import { CHECK_TYPES_VALUES } from "../constants/Checks";

export const ChecksMapper = items => {
  const mapper = item => ({
    id: item.cheId,
    type: CHECK_TYPES_VALUES.find(oType => oType.value === item.cheTipo),
    bank: {
      id: item.banId,
      name: item.banNom,
    },
    code: item.cheSerNro,
    currency: {
      id: item.monId,
      code: item.monSim,
    },
    amount: item.cheImporte,
    partner: {
      id: item.socId,
      name: item.socNom,
    },
    date: item.cheFchIng,
    expiration: item.cheFchVenc,
    observations: item.cheObs,
  });

  if (Array.isArray(items)) return items.map(mapper);
  if ((typeof items).toString() === "object") return mapper(items);
  return null;
};

export const BanksMapper = items => {
  const mapper = item => ({
    id: item.banId,
    value: item.banId,
    name: item.banNom,
    label: item.banNom,
  });

  if (Array.isArray(items)) return items.map(mapper);
  if ((typeof items).toString() === "object") return mapper(items);
  return null;
};

export const ChecksUnMapper = items => {
  const unMapper = item => ({
    cheId: item.id ?? 0,
    cheSerNro: item.code,
    cheTipo: item.type,
    banId: item.bank,
    monId: item.currency,
    cheImporte: item.amount,
    socId: item.partner,
    cheFchIng: item.date,
    cheFchVenc: item.expiration,
    cheObs: item.observations,
  });

  if (Array.isArray(items)) return items.map(unMapper);
  if ((typeof items).toString() === "object") return unMapper(items);
  return null;
};
